<template>
    <div>
        <config-main-title>
            Autorizar Máquina
        </config-main-title>

        <template v-if="maquinas">
        
            <div class="mb-3">
                <az-input
                    placeholder="Informe um nome para essa máquina... (contendo apenas letras, números e traços)..."
                    v-model="nome"
                    :validate="validate">
                    <template v-slot:buttonposb>
                        <div class="input-group-append">
                            <button type="button" class="btn btn-outline-primary" v-if="!valido || !chave" @click="gerar()">Gerar</button>
                            <div class="input-group-append" v-else-if="valido">
                                <span class="input-group-text" id="basic-addon2">
                                    <i class="fa fa-check text-success" aria-hidden="true"></i>
                                </span>
                            </div>
                        </div>
                    </template>
                </az-input>
            </div>

            <ul class="list-group">
                <li class="list-group-item" :class="valido && maquina == validacao.maquina ? 'active' : ''" v-for="(maquina, imx) in maquinas" :key="imx">
                    <button type="button" class="btn btn-sm mr-2" 
                        :class="valido && maquina == validacao.maquina ? 'btn-danger' : 'btn-outline-danger'" 
                        @click="remover(maquina)">
                        <i class="fas fa-trash-alt"></i>
                    </button>
                    {{ maquina }}
                </li>
            </ul>

            <p class="alert alert-info mt-3">
                Recurso para autorizar essa máquina para usuários que só podem acessar o sistema em máquinas autorizadas.<br><br>
                Deve ser informado um nome para máquina e clicado no botão gerar, pra que seja gerada a autorização de acesso nessa máquina.<br><br>
                No cadastro do usuário, deve ser indicado que ele tem acesso somente em máquinas autorizadas.
            </p>

            <hr>

            <div class="alert alert-secondary d-flex justify-content-between">
                <span>
                    Autorização por IP
                    <div v-if="info" class="small text-muted">
                        IP Atual: {{ info.ip }} <span v-if="info.clientip && ( info.clientip !== info.ip )"> | {{ info.clientip }}</span>
                    </div>
                </span>
                <a href="#" class="card-link" @click.prevent="editar_ips()">
                    <i class="fas fa-edit"></i>
                </a>
            </div>

            <div v-if="!ips || !ips.length">
                <div class="alert alert-warning">
                    Nenhum IP autorizado.
                </div>
            </div>

            <ul class="list-group" v-else>
                <li class="list-group-item" v-for="(ip, imx) in ips" :key="imx">
                    {{ ip }}
                </li>
            </ul>

        </template>

        <!-- Lista IPs -->
        <div class="modal fade" id="listaIpsModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">IPs Autorizados</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body" v-if="edicao_ips">
                        <div class="alert alert-secondary d-flex justify-content-between">
                            <span>
                                Autorização por IP
                                <div v-if="info" class="small text-muted">
                                    IP Atual: {{ info.ip }} <span v-if="info.clientip && ( info.clientip !== info.ip )"> | {{ info.clientip }}</span>
                                </div>
                            </span>
                        </div>

                        <div v-if="!edicao_ips || !edicao_ips.length">
                            <div class="alert alert-warning">
                                Nenhum IP autorizado.
                            </div>
                        </div>

                        <ul class="list-group mb-3" v-else>
                            <li class="list-group-item d-flex justify-content-between hover-bg" v-for="(ip, imx) in edicao_ips" :key="imx">
                                <div>
                                    <input type="text" class="form-control form-control-sm" v-model="edicao_ips[imx]" placeholder="Informe o número IP...">
                                </div>
                                <div>
                                    <a class="card-link text-danger" @click.prevent="edicao_ips.splice(imx, 1)">
                                        <i class="fas fa-trash-alt"></i>
                                    </a>
                                </div>
                            </li>
                        </ul>

                        <button type="button" class="btn btn-sm btn-outline-primary" @click="edicao_ips.push('')">
                            <i class="fas fa-plus" aria-hidden="true"></i>
                        </button>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar_ips()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() { 
        return { 
            maquinas: null,
            nome: "",
            chave: "", 
            validacao: null, 
            validate: false, 
            ips: [], 
            info: null, 
            edicao_ips: null, 
        }
    },
    
    components: { 
        AzInput, 
        ConfigMainTitle,
        AzSubmit,
    },

    computed: { 
        valido: function () { 
            return this.validacao && this.validacao.maquina == this.nome;
        }
    },

    methods: { 
        atualizar_ips () { 
            this.$util.atualizar(this, { 
                service: 'fingerprints',
                func: 'atualizar_ips',
                dados: { 
                    lista: this.edicao_ips, 
                },
                modal: 'listaIpsModal',
                reload: true, 
                toast: true, 
            });
        },

        editar_ips () { 
            this.edicao_ips = _.cloneDeep(this.ips);
            $('#listaIpsModal').modal('show');
        },

        gerar() { 
            this.$util.atualizar(this, { 
                service: 'fingerprints',
                func: 'gerar',
                dados: { 
                    nome: this.nome, 
                },
                callback: res => { 
                    this.$util.setCookie('maquina', res.maquina, 9999);
                    this.$util.setCookie('maquina.' + res.maquina, res.chave, 9999);
                },
                reload: true, 
                toast: true, 
            });
        },

        remover(maquina) { 
            this.$util.atualizar(this, { 
                service: 'fingerprints',
                func: 'remover',
                dados: { 
                    nome: maquina, 
                },
                callback: () => { 
                    this.load();
                }
            });

        },

        load() { 
            this.$util.load(this, { 
                service: 'fingerprints',
                func: 'listar_com_ips',
                loadTo: res => { 
                    this.maquinas = res.lista;
                    this.ips = res.ips; 
                    this.info = res; 
                    this.validar();
                }
            });
        },

        validar() { 

            if ( this.nome ) { 

                this.chave = this.$util.getCookie('maquina.' + this.nome);

                this.$util.loadItem(this, { 
                    service: 'fingerprints',
                    func: 'validar',
                    parms: { 
                        nome: this.nome,
                        chave: this.chave,
                    }
                })
                .then(res => { 
                    this.validacao = res;
                });

            }

        }
    },

    mounted() { 

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Autorizar Máquina" },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.nome = this.$util.getCookie('maquina');

        this.$util.valid_permissao(this, 88, this.load);

    },
}
</script>